module.exports = __webpack_public_path__ + "static/media/NunitoSans-SemiBold.bd318b58.ttf";